import React, { Component } from "react";
//Alert dialog

import { connect } from "react-redux";
import ProductTextField from "./ProductTextField";
import ProductCheckBoxField from "./ProductCheckBoxField";
import ProductFileField from "./ProductFileField";
import MainGroup from "../ProductOptions/Groups/MainGroup";

class ProductExtraFields extends Component {
  render() {
    const selectedExtraFields = this.props.selectedExtraFields;
    const optionsGroups = this.props.optionsGroups;
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    let extraFields = [];
    if (optionsGroups.length > 0) {
      extraFields = [];
      extraFields = optionsGroups.map((og) => (
        <MainGroup key={og.id} sortOrder={og.sort_order} group={og}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap", // Allow components to wrap to the next line
              justifyContent: "space-between",
            }}
          >
            {this.props.extraFields
              .filter((o) => o.groups.includes(og.id))
              .map((extraField, index) => (
                <div
                  key={extraField.id + "-" + og.id}
                  style={{
                    flex: `0 0 ${100 / (og.columns || 1)}%`,
                    width: 100 / (og.columns || 1),
                    marginBottom: "2px",
                    height: "100%",

                    // flexGrow: 1,
                  }}
                >
                  {extraField.type == "text" ? (
                    <ProductTextField
                      extraField={extraField}
                      setExtrafield={this.props.setExtrafield}
                      selectedExtraField={
                        selectedExtraFields[extraField.id + "-" + og.id]
                      }
                      themeColor={themeColor}
                      groupID={og.id}
                      sortOrder={extraField.sort_order}
                      extraID={extraField.id + "-" + og.id}
                    />
                  ) : extraField.type == "checkbox" ? (
                    <ProductCheckBoxField
                      extraField={extraField}
                      setExtrafield={this.props.setExtrafield}
                      selectedExtraField={
                        selectedExtraFields[extraField.id + "-" + og.id]
                      }
                      themeColor={themeColor}
                      groupID={og.id}
                      sortOrder={extraField.sort_order}
                      extraID={extraField.id + "-" + og.id}
                    />
                  ) : extraField.type == "file" ? (
                    <ProductFileField
                      extraField={extraField}
                      setExtrafield={this.props.setExtrafield}
                      selectedExtraField={{
                        ...selectedExtraFields[extraField.id + "-" + og.id],
                      }}
                      themeColor={themeColor}
                      groupID={og.id}
                      sortOrder={extraField.sort_order}
                      extraID={extraField.id + "-" + og.id}
                    />
                  ) : null}
                </div>
              ))}
          </div>
        </MainGroup>
      ));

      // change to single loop and check if group was deleted :)
      this.props.extraFields
        .sort((a, b) => a.sort_order - b.sort_order)
        .forEach((extraField) => {
          if (extraField.groups.length <= 0) {
            extraFields.push(
              extraField.type == "text" ? (
                <ProductTextField
                  key={extraField.id}
                  extraField={extraField}
                  setExtrafield={this.props.setExtrafield}
                  selectedExtraField={selectedExtraFields[extraField.id]}
                  themeColor={themeColor}
                  sortOrder={extraField.sort_order}
                  extraID={extraField.id}
                />
              ) : extraField.type == "checkbox" ? (
                <ProductCheckBoxField
                  key={extraField.id}
                  extraField={extraField}
                  setExtrafield={this.props.setExtrafield}
                  selectedExtraField={selectedExtraFields[extraField.id]}
                  themeColor={themeColor}
                  sortOrder={extraField.sort_order}
                  extraID={extraField.id}
                />
              ) : extraField.type == "file" ? (
                <ProductFileField
                  key={extraField.id}
                  extraField={extraField}
                  setExtrafield={this.props.setExtrafield}
                  selectedExtraField={{
                    ...selectedExtraFields[extraField.id],
                  }}
                  themeColor={themeColor}
                  sortOrder={extraField.sort_order}
                  extraID={extraField.id}
                />
              ) : null
            );
          }
        });

      extraFields.sort((a, b) => a.props.sortOrder - b.props.sortOrder);
    } else {
      extraFields = this.props.extraFields
        .sort((a, b) => a.sort_order - b.sort_order)
        .map((extraField) => {
          if (extraField.type == "text") {
            return (
              <ProductTextField
                key={extraField.id}
                extraField={extraField}
                setExtrafield={this.props.setExtrafield}
                selectedExtraField={selectedExtraFields[extraField.id]}
                extraID={extraField.id}
              />
            );
          } else if (extraField.type == "checkbox") {
            return (
              <ProductCheckBoxField
                key={extraField.id}
                extraField={extraField}
                setExtrafield={this.props.setExtrafield}
                selectedExtraField={selectedExtraFields[extraField.id]}
                extraID={extraField.id}
              />
            );
          } else if (extraField.type == "file") {
            return (
              <ProductFileField
                key={extraField.id}
                extraField={extraField}
                setExtrafield={this.props.setExtrafield}
                selectedExtraField={{ ...selectedExtraFields[extraField.id] }}
                extraID={extraField.id}
              />
            );
          }
        });
    }

    return extraFields;
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(ProductExtraFields);
